import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=0d254c9c&scoped=true"
import script from "@/views/Settings/Sizes/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Sizes/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Sizes/create-dialog.scss?vue&type=style&index=0&id=0d254c9c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d254c9c",
  null
  
)

export default component.exports